<script>

import api from '@/api'
import bus from '@/bus'
import * as nativeBridge from '@/native-bridge'

import { saveAs } from 'file-saver'

export default {
    methods: {
        downloadFile(url) {
            this.$store.dispatch('START_LOADING')
            api.get(url, true, false).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                if (this.$store.state.isInApp) {
                    // Native shell saves it via the OS sheet. Chunked encoding and
                    // per-host framing both live in the bridge module.
                    if (!nativeBridge.postDocument({intent: 'download', bytes: resp, filename: 'download.pdf'})) {
                        throw {'__all__': ["Error saving file"]}
                    }
                } else {
                    // TODO: make filename customizable
                    saveAs(new Blob([resp], {type: "application/pdf"}), `download.pdf`)
                }
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                bus.showError(bus.firstError(errors))
            })
        },
    },
}

</script>
